import { isNil } from '@lucidlink/tscore';
import { SettingName, SettingTarget } from '#config/types';
import { createBase64RsaCrypto, createRsaCrypto, RSA_DEFAULT_SCHEME } from '#crypto/node-forge';
export const createServerCryptoProvider = (config) => {
    return new ServerCryptoProvider(config);
};
class ServerCryptoProvider {
    config;
    serverCrypto;
    constructor(config) {
        this.config = config;
    }
    async getCrypto() {
        if (isNil(this.serverCrypto)) {
            this.serverCrypto = createBase64RsaCrypto(await this.createServerRsaCrypto());
        }
        return this.serverCrypto;
    }
    async createServerRsaCrypto() {
        const serverCryptoKeySetting = await this.config.get([
            {
                target: SettingTarget.FS_INIT,
                name: SettingName.SERVER_RSA_PUBLIC,
            },
        ]);
        return createRsaCrypto({
            scheme: RSA_DEFAULT_SCHEME,
            serializedPublicKey: serverCryptoKeySetting[0].effective().asString(),
        });
    }
}
